import React, { FC, useState } from 'react'
import { IHeaderGroupParams } from 'ag-grid-community'
import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'
import { rfqIconSet } from '../shared/rfqIconSet'
export interface PivotedRowGroupedColumnHeaderComponent extends IHeaderGroupParams {
  children: string[]
  isModifiedValues: boolean
}

interface IconContainerProps {
  isModified: boolean
}

const CellWrapper = styled.div`
  width: 100%;
  height: 100%;
  flex: 1 1 100%;
`

const LabelContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const HeaderName = styled.div`
  height: 100%;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: ProximaNova;
  font-weight: ${constants.FontWeight.SemiBold};
  color: ${constants.CORE_PRIMARY_6};
`

const IconContainer = styled.div`
  background-color: ${(props: IconContainerProps) => props.isModified && '#8933bf'};
  border-radius: 4px;
  flex: 0 0 16px;
  display: flex;
  align-items: center;
  height: 17px;
  width: 21px;
  cursor: pointer;
  color: ${(props: IconContainerProps) => (props.isModified ? '#fff' : constants.CORE_PRIMARY_5)};
  svg {
    margin: 3px 0 0 2px;
    height: 14px;
  }
`

export const PivotedRowGroupedColumnHeaderComponent: FC<PivotedRowGroupedColumnHeaderComponent> = props => {
  const { columnGroup, displayName, isModifiedValues } = props
  const isExpanded = columnGroup.getDisplayedChildren()?.length === columnGroup.getChildren()?.length
  const [isColumnGroupExpanded, setIsColumnGroupExpanded] = useState(isExpanded)

  const onToggleClick = () => {
    setIsColumnGroupExpanded(prevState => !prevState)
    props.setExpanded(!isColumnGroupExpanded)
  }

  return (
    <CellWrapper>
      <LabelContainer className="ag-header-cell-label" role="presentation">
        <HeaderName>{displayName}</HeaderName>
        <IconContainer className="ag-header-custom-arrow-icon" role="presentation" onClick={onToggleClick} isModified={isModifiedValues}>
          {isColumnGroupExpanded ? rfqIconSet.deltaArrowToggleCollapse : rfqIconSet.deltaArrowToggleExpand}
        </IconContainer>
      </LabelContainer>
    </CellWrapper>
  )
}

export const PivotedRowGroupedColumnHeaderWithoutExpandedComponent: FC<PivotedRowGroupedColumnHeaderComponent> = props => {
  const { displayName } = props

  return (
    <CellWrapper>
      <LabelContainer className="ag-header-cell-label" role="presentation">
        <HeaderName>{displayName}</HeaderName>
      </LabelContainer>
    </CellWrapper>
  )
}
